"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptBannerUpgradeContent = exports.PromptBanner = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var PromptDismissible_1 = require("./PromptDismissible");
var inversify_react_1 = require("inversify-react");
var PromptBanner = function (_a) {
    var promptId = _a.promptId, className = _a.className, children = _a.children;
    var Banner = function (_a) {
        var onDismiss = _a.onDismiss;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Close, { size: icons_1.IconSize.Small }), className: "prompt-banner-dismiss", onClick: onDismiss }),
            react_1.default.createElement(kaleidoscope_1.Card, { className: "prompt-banner__content-card", elevation: 2 }, children)));
    };
    return (react_1.default.createElement(PromptDismissible_1.PromptDismissible, { promptId: promptId, className: "prompt-banner-root ".concat(className) },
        react_1.default.createElement(Banner, null)));
};
exports.PromptBanner = PromptBanner;
var c = (0, BemBuilder_1.default)("prompt-banner-content");
var PromptBannerUpgradeContent = function (_a) {
    var heading = _a.heading, subtitle = _a.subtitle, button = _a.button;
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    return (react_1.default.createElement("div", { className: c("", isMobile() ? "mobile" : "") },
        react_1.default.createElement("img", { className: c("image"), src: "/Assets/Images/report-upsell.svg" }),
        react_1.default.createElement(kaleidoscope_1.Heading, { className: c("heading"), level: "3", strong: true }, heading),
        react_1.default.createElement(kaleidoscope_1.Text, { className: c("subtitle"), size: "l", align: isMobile() ? "center" : "left" }, subtitle),
        react_1.default.createElement("div", { className: c("button") }, button)));
};
exports.PromptBannerUpgradeContent = PromptBannerUpgradeContent;
